import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const rigbotConfig: TSPConfig = {
  key: 'rigbot',
  name: 'Rigbot',
  imageName: 'Rigbot',
  category: TSPCategory.API_KEY,
  helpText:
    'Please enter your Rigbot API key and the carrier USDOT number. ' +
    'The API key can be obtained from the Rigbot portal or by contacting Rigbot Support (844-474-4268).',
  loginComponent: (props) => (
    <LoginCreds
      fields={[
        { name: 'apikey', label: 'Enter API key' },
        { name: 'authorizationcode', label: 'Enter USDOT number' },
      ]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default rigbotConfig;
